import t from '../common/localization'

export default {
'driverName': {
    name: t('driverName'),
    type: 'string',
  },
  'sim': {
    name: t('deviceSim'),
    type: 'string',
  },
  'apn': {
    name: t('deviceApn'),
    type: 'string',
  },
'remarks': {
    name: t('deviceRemarks'),
    type: 'string',
  },
'devicePassword': {
    name: t('attributeDevicePassword'),
    type: 'string',
  },
'processing.copyAttributes': {
      name: t('attributeProcessingCopyAttributes'),
      type: 'string',
    },
'processing.copyAttributesSecondary': {
    name: t('attributeProcessingCopyAttributesSecondary'),
    type: 'string',
  },
  'forward.position.enable': {
    name: t('attributeForwardPositionEnable'),
    type: 'boolean',
  },
  'forward.position.url': {
    name: t('attributeForwardPositionUrl'),
    type: 'string',
  },
  'forward.position.template': {
    name: t('attributeForwardPositionTemplate'),
    type: 'string',
  },
  'forward.position.header': {
    name: t('attributeForwardPositionHeader'),
    type: 'string',
  },
  'forward.position.interval': {
    name: t('attributeForwardPositionInterval'),
    type: 'number',
  },
'time.override.deviceTime': {
    name: t('attributeTimeOverrideDeviceTime'),
    type: 'boolean',
  },
  'time.override.serverTime': {
    name: t('attributeTimeOverrideServerTime'),
    type: 'boolean',
  },
 'filter.distance': {
    name: t('attributeFilterDistance'),
    type: 'boolean',
  },
  'filter.invalid': {
    name: t('attributeFilterInvalid'),
    type: 'boolean',
  },
  'filter.old': {
    name: t('attributeFilterOld'),
    type: 'boolean',
  },
  'filter.maxSpeed': {
    name: t('attributeFilterMaxSpeed'),
    type: 'number',
  },
  'coordinates.minError': {
    name: t('attributeCoordinatesMinError'),
    type: 'number',
  },
  'coordinates.minError.ignitionOff': {
    name: t('attributeCoordinatesMinErrorIgnitionOff'),
    type: 'number',
  },
  'coordinates.maxError': {
    name: t('attributeCoordinatesMaxError'),
    type: 'number',
  },
  'report.useDistanceForMileageFuel': {
    name: t('attributeUseDistanceForMileageFuel'),
    type: 'boolean',
  },
  'speedLimit': {
    name: t('attributeSpeedLimit'),
    type: 'number',
  },
  'report.ignoreOdometer': {
    name: t('attributeReportIgnoreOdometer'),
    type: 'boolean',
  },
  'web.reportColor': {
    name: t('attributeWebReportColor'),
    type: 'string',
  },
 'overstayDetectTime': {
     name: t('attributeOverstayDetectTime'),
     type: 'number',
   },
   'idleDetectTime': {
     name: t('attributeIdleDetectTime'),
     type: 'number',
  },
 'fuelDropThreshold': {
     name: t('attributeFuelDropThreshold'),
     type: 'number',
   },
   'refuelThreshold': {
     name: t('attributeRefuelThreshold'),
     type: 'number',
   },
   'fuelMileage': {
     name: t('attributeFuelMileage'),
     type: 'number',
  },
  'decoder.timezone': {
    name: t('sharedTimezone'),
    type: 'timezone',
  },
  'deviceInactivityStart': {
    name: t('attributeDeviceInactivityStart'),
    type: 'boolean',
  },
  'deviceInactivityPeriod': {
    name: t('attributeDeviceInactivityPeriod'),
    type: 'number',
  },
  'parkingMode': {
    name: t('attributeParkingMode'),
    type: 'number',
  },
  'commandPermission': {
    name: t('attributeCommandPermission'),
    type: 'number',
  },
 'useUnnecessaryAlarms': {
   name: t('attributeUseUnnecessaryAlarms'),
   type: 'string',
 }
};
